const title = "Design Your Own – Custom Team Banner Maker";
export {title}